<template>
	<span>
		<span
			class="spinner-border spinner-border-sm mr-2"
			role="status"
			aria-hidden="true"
			></span>{{ showText ? 'Loading...' : null }}
	</span>
</template>

<script>

export default {
	name: "Loading",
	props: ['showText']
};
</script>

<style>
</style>